import { useRef } from "react";
import {observer} from "mobx-react";

import classNames from "classnames";
import styles from "./styles/_BlockCS.module.scss";

import dynamic from 'next/dynamic';
import ErrorBlock from "../SchoolBlocks/ErrorBlock";

export const enum CleverBlockTypes {
    EVENTS = "events",
    MESSAGE = "message",
    NEWS = "news",
    VIDEO = "video",
    GALLERY = "gallery",
    ABOUT = "about",
    MAP = "map",
    QUICKLINKS = "quicklinks",
    REVIEWS = "reviews",
    HTML = "html",
    FILES_FOLDERS = "files_folders",
}

const blockTypes = {
    "map": dynamic(() => import("./MapBlock/MapBlock")),
};

const Block = observer((props: {
    blockObj: ITerraceBlock,
}) => {
    const blockRef = useRef<HTMLElement | null>(null);

    const BlockTypeComponent = blockTypes[props.blockObj.type] || ErrorBlock;

    const blockClassName = classNames({
        [styles.block]: true,
        [styles.blockPadded]: props.blockObj.type !== CleverBlockTypes.MAP,
        [styles.typeNewsstream]: props.blockObj.type === CleverBlockTypes.NEWS,
        [styles.typeEventlist]: props.blockObj.type === CleverBlockTypes.EVENTS,
    });

    return (
        <article
            className={blockClassName}
            data-id={props.blockObj.id}
            data-block-type={props.blockObj.type}
            ref={blockRef}
        >
            <BlockTypeComponent blockObj={props.blockObj} />
        </article>
    );
});

export default Block;
